import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import { userScopeCleared } from '@krp/client-runtime'

import { DEFAULT_ROLE, PLATFORM_ROLES } from './roles'
import type { AccessIntentState } from './types'

/**
 * Намерение на экране прав: открытая роль. Галочки до «Сохранить» живут в
 * экране, допуск и матрица — в кэше запросов. Срок жизни — `screen`.
 */
const initialState: AccessIntentState = { role: DEFAULT_ROLE }

const accessSlice = createSlice({
  name: 'platform/access',
  initialState,
  reducers: {
    accessRoleChanged(state, action: PayloadAction<string>) {
      if (PLATFORM_ROLES.some((role) => role.value === action.payload)) state.role = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(userScopeCleared, () => initialState)
  },
})

export const { accessRoleChanged } = accessSlice.actions
export const accessReducer = accessSlice.reducer

export function decodeAccessRole(raw: unknown): string | undefined {
  return typeof raw === 'string' && PLATFORM_ROLES.some((role) => role.value === raw) ? raw : undefined
}
